import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import "hammerjs";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { MSAL_INSTANCE } from "@azure/msal-angular";
import { PublicClientApplication } from "@azure/msal-browser";

if (environment.production) enableProdMode();

const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

function actualStart(clientId: string, tenantId: string) {
  {
    platformBrowserDynamic([
      {
        provide: MSAL_INSTANCE,
        useValue: new PublicClientApplication({
          auth: {
            clientId: clientId,
            authority: `https://login.microsoftonline.com/${tenantId}`,
            redirectUri: `${window.location.origin}${
              environment.production ? "/en" : ""
            }/welcome`,
          },
          cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: isIE,
          },
        }),
      },
    ])
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  }
}

fetch("/config")
  .then((response) => response.json())
  .then((json) => actualStart(json.clientId, json.tenantId))
  .catch(() => actualStart(environment.clientId, environment.tenantId));
